<div class="static-text">
    <span>{{ normalizedLabel }}</span>
    <span class="static-text__value">{{ value }}</span>
</div>

